import { AppFunctionComponent } from "../../../types"
import React, { ReactNode } from "react"
import styled from "styled-components"
import Section from "../../../components/common/sections/section.component"

const Wrapper = styled.div`
  & + * {
    margin-top: calc(var(--grid-spacing) * -1 + 10px);
  }
`

interface Props {
  breadcrumbsMenu: ReactNode
  landing?: boolean
}

const TopNavigationWrapper: AppFunctionComponent<Props> = ({
  landing,
  breadcrumbsMenu,
}) => {
  return !landing ? (
    <Wrapper>
      {" "}
      <Section>{breadcrumbsMenu}</Section>
    </Wrapper>
  ) : (
    <></>
  )
}

export default TopNavigationWrapper
